var DotObjectEditModal = (function (base) {
  __extends(DotObjectEditModal, base);


  function DotObjectEditModal(apiClient) {
    const self = base.call(this, apiClient) || this;
    return self;
  };


  DotObjectEditModal.prototype.activate = function (dotObjectId) {
    const self = this;
    const isNew = !dotObjectId;
    const url = isNew ? 'api/dotObjects/add' : 'api/dotObjects/{0}/edit'.format(dotObjectId);

    this.loadContent(url)
      .then($modal => {

        var $form = $('form', $modal);

          var typeId = parseInt($('#TypeId', $modal).val());
            var type = doTypes.filter(function (t) { return t.Id === typeId; })[0];
          $('#FreeLocation').val(type.FreeLocation ? "True" : "False");
            var onMap = type.FreeLocation;
            if (type.FreeLocation) {
                $('[js=on-map]').show();
                $('[js=on-road]').hide();
                coordinates.updateFreeLocation();
            } else {
                $('[js=on-map]').hide();
                $('[js=on-road]').show();
                coordinates.reloadRoadCoordinates().then(function () {
                    coordinates.updateCoordinates({ isPoint: true, ignoreCoordinate: true });
                });
            }

            FormHelper.init($form, isNew ? 'PUT' : 'POST', 'api/dotObjects');
        FilesUploader.initUploadingOnSubmit(VideoServerSettings.url, $form, "UploadedFile",
          function () {
            //2-видео, 3-фото
            const type = $('#TypeId', $form).val();
            return type === '2' || type === '3';
          },
          function (fileType) {
            const type = $('#TypeId', $form).val();

            return type === '2' && fileType === 2
              || type === '3' && fileType === 3
              || type !== '2' && type !== '3' && (fileType === 2 || fileType === 3);
          });

        $modal

          //Кнопка 'Сохранить'
          .on('click', '[js=save]', function () {
            $modal.busy();
            $form.send()
              .then(() => self.close({ ok: true }))
              .catch(() => $modal.busy(false));
          })
            // При смене вида объекта проверить обязательность наличия файла
            .on('change', '#TypeId', (e) => {
                $form.find('.fileinput').trigger('update.bs.fileinput');
                var onMap = $('#FreeLocation').val() === 'True';
                var typeId =  parseInt($(e.target).val());
                var type = doTypes.filter(function (t) {
                    return t.Id === typeId;
                })[0];
                if (onMap != type.FreeLocation) {
                    $('#FreeLocation').val(type.FreeLocation ? "True" : "False");
                    if (type.FreeLocation) {
                        $('[js=on-map]').show();
                        $('[js=on-road]').hide();
                        coordinates.updateFreeLocation();
                    } else {
                        $('[js=on-map]').hide();
                        $('[js=on-road]').show();
                        coordinates.reloadRoadCoordinates()
                            .then(() => {
                                coordinates.updateCoordinates({ isPoint: true, ignoreCoordinate: true });
                            });
                    }
                }
            })

          //Выбор кода автодороги
            .on('change', '#RoadId', () => {
            coordinates.reloadRoadCoordinates()
              .then(() => {
                  coordinates.updateCoordinates({ isPoint: true, ignoreCoordinate: true });
              });
            })


          //Изменение километра МС на дороге
          .on('change', '#Location', () => {
              coordinates.updateCoordinates({ isPoint: true, ignoreCoordinate: true });
            })
            //Изменение широты
            .on('change', '#Lat', () => {
                coordinates.updateFreeLocation();
            })
            //Изменение долготы
            .on('change', '#Lng', () => {
                coordinates.updateFreeLocation();
            })


            //Кнопка 'Задать координату на карте'
            .on('click', '[js=edit-on-map]', () => {

                const dotObjectName = $('#Name', $modal).val();
                const lat = $('#Lat', $modal).val();
                const lng = $('#Lng', $modal).val();

                ModalConductor.activate(DotObjectFreeMapModal, dotObjectId, dotObjectName, lat, lng)
                    .on('closed',
                        modalResult => {
                            if (modalResult.ok) {
                                $('#Lat', $modal).val(modalResult.coordinate.lat);
                                $('#Lng', $modal).val(modalResult.coordinate.lng);
                            }
                        });
            })

                //Кнопка 'Задать координату на дороге'
          .on('click', '[js=edit-coordinates]', () => {

            const roadId = parseInt($('#RoadId option:selected', $modal).val());
            const dotObjectName = $('#Name', $modal).val();
            const location = parseFloat($('#Location', $modal).val());
            const roadStartKm = coordinates.getRoadStartKm(roadId);

            ModalConductor.activate(DotObjectMapModal, dotObjectId, roadId, dotObjectName, roadStartKm, location)
              .on('closed',
                modalResult => {
                  if (modalResult.ok) {
                    $('#Location', $modal).val(modalResult.location);
                  }
                });
          });
      });
  };


  return DotObjectEditModal;
}(BaseModal));
